import '@/plugins/kyPlugin'

import camelCase from 'lodash/camelCase'
import upperFirst from 'lodash/upperFirst'
import VueMask from 'v-mask'
import Vue from 'vue'
import Vuelidate from 'vuelidate'

import App from '@/App.vue'
import aiPlugin from '@/plugins/aiPlugin'
import i18n from '@/plugins/i18n.js'
import msalPlugin from '@/plugins/msalPlugin'
import vuetify from '@/plugins/vuetify'
import router from '@/router'
import store from '@/store'

import { name as appName } from '../package.json'
import filters from './filters'

// setup global eventbus object
Vue.prototype.$eventBus = new Vue()

// automatic global components registration
const requireComponent = require.context(
  './components',
  true,
  /[A-Z]\w+\.(vue|js)$/
)
requireComponent.keys().forEach(fileName => {
  console.info('registering component:', fileName)
  const componentConfig = requireComponent(fileName)

  const componentName = upperFirst(
    camelCase(
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  )

  Vue.component(componentName, componentConfig.default || componentConfig)
})

const msalPluginOptions = {
  clientId: process.env.VUE_APP_MSAL_CLIENT_ID,
  commonAuthority: process.env.VUE_APP_MSAL_COMMON_AUTHORITY,
  defaultScopes: process.env.VUE_APP_MSAL_DEFAULT_SCOPES,
  logLevel: process.env.VUE_APP_MSAL_LOGLEVEL ? parseInt(process.env.VUE_APP_MSAL_LOGLEVEL) : 0
}

if (process.env.NODE_ENV === 'mock') {
  msalPluginOptions.mock = {
    accessToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiSm9obiBEb2UiLCJpYXQiOjE2Mzc1NjUxODgsImV4cCI6MTYzNzY1MTU4OH0.3vZJyrKPj-u9MNBRh7-THrC2hx_DNwXZPciKYLT20hE',
    account: {
      name: 'John Doe'
    }
  }
}

Vue.use(msalPlugin, msalPluginOptions)
Vue.use(aiPlugin, { router, appName, instrumentationKey: process.env.VUE_APP_AI_INSTRUMENTATION_KEY })
Vue.use(Vuelidate)
Vue.use(VueMask)

// global filters registration
for (const name in filters) {
  Vue.filter(name, filters[name])
}

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
